import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateBlockingRuleMutationVariables = Types.Exact<{
  input: Types.CreateBlockingRuleInput;
}>;


export type CreateBlockingRuleMutation = { __typename?: 'Mutation', createBlockingRule: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateBlockingRuleMutationVariables = Types.Exact<{
  input: Types.UpdateBlockingRuleInput;
}>;


export type UpdateBlockingRuleMutation = { __typename?: 'Mutation', updateBlockingRule: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteBlockingRuleMutationVariables = Types.Exact<{
  input: Types.DeleteBlockingRuleInput;
}>;


export type DeleteBlockingRuleMutation = { __typename?: 'Mutation', deleteBlockingRule: { __typename?: 'BlockingRulePayload', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreatePromotionRuleMutationVariables = Types.Exact<{
  input: Types.CreatePromotionRuleInput;
}>;


export type CreatePromotionRuleMutation = { __typename?: 'Mutation', createPromotionRule: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdatePromotionRuleMutationVariables = Types.Exact<{
  input: Types.UpdatePromotionRuleInput;
}>;


export type UpdatePromotionRuleMutation = { __typename?: 'Mutation', updatePromotionRule: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeletePromotionRuleMutationVariables = Types.Exact<{
  input: Types.DeletePromotionRuleInput;
}>;


export type DeletePromotionRuleMutation = { __typename?: 'Mutation', deletePromotionRule: { __typename?: 'PromotionRulePayload', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateBlockingRuleDocument = new TypedDocumentString(`
    mutation CreateBlockingRule($input: CreateBlockingRuleInput!) {
  createBlockingRule(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdateBlockingRuleDocument = new TypedDocumentString(`
    mutation UpdateBlockingRule($input: UpdateBlockingRuleInput!) {
  updateBlockingRule(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeleteBlockingRuleDocument = new TypedDocumentString(`
    mutation DeleteBlockingRule($input: DeleteBlockingRuleInput!) {
  deleteBlockingRule(input: $input) {
    blockingRule {
      ...BlockingRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const CreatePromotionRuleDocument = new TypedDocumentString(`
    mutation CreatePromotionRule($input: CreatePromotionRuleInput!) {
  createPromotionRule(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const UpdatePromotionRuleDocument = new TypedDocumentString(`
    mutation UpdatePromotionRule($input: UpdatePromotionRuleInput!) {
  updatePromotionRule(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const DeletePromotionRuleDocument = new TypedDocumentString(`
    mutation DeletePromotionRule($input: DeletePromotionRuleInput!) {
  deletePromotionRule(input: $input) {
    promotionRule {
      ...PromotionRuleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateBlockingRule: build.mutation<CreateBlockingRuleMutation, CreateBlockingRuleMutationVariables>({
      query: (variables) => ({ document: CreateBlockingRuleDocument, variables })
    }),
    UpdateBlockingRule: build.mutation<UpdateBlockingRuleMutation, UpdateBlockingRuleMutationVariables>({
      query: (variables) => ({ document: UpdateBlockingRuleDocument, variables })
    }),
    DeleteBlockingRule: build.mutation<DeleteBlockingRuleMutation, DeleteBlockingRuleMutationVariables>({
      query: (variables) => ({ document: DeleteBlockingRuleDocument, variables })
    }),
    CreatePromotionRule: build.mutation<CreatePromotionRuleMutation, CreatePromotionRuleMutationVariables>({
      query: (variables) => ({ document: CreatePromotionRuleDocument, variables })
    }),
    UpdatePromotionRule: build.mutation<UpdatePromotionRuleMutation, UpdatePromotionRuleMutationVariables>({
      query: (variables) => ({ document: UpdatePromotionRuleDocument, variables })
    }),
    DeletePromotionRule: build.mutation<DeletePromotionRuleMutation, DeletePromotionRuleMutationVariables>({
      query: (variables) => ({ document: DeletePromotionRuleDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateBlockingRuleMutation, useUpdateBlockingRuleMutation, useDeleteBlockingRuleMutation, useCreatePromotionRuleMutation, useUpdatePromotionRuleMutation, useDeletePromotionRuleMutation } = injectedRtkApi;
